import Vue from 'vue';
// @ts-ignore
import VueQRCodeComponent from 'vue-qr-generator';
export default Vue.extend({
    name: 'qrZoomPopupChunk',
    props: {
        slotData: {
            required: true
        }
    },
    data: () => ({
        QRCodeSize: 10,
        letShowQR: true
    }),
    mounted() {
        const vm = this;
        vm.letShowQR = false;
        setTimeout(() => {
            vm.QRCodeSize = vm.$refs.qrWrapper.clientWidth - 8;
            vm.letShowQR = true;
        }, 0);
    },
    components: {
        'qr-code': VueQRCodeComponent
    }
});
